import React, { forwardRef } from 'react';
import { FabButton } from '@phoenix/design-system/frontend/ui/fab/fab-button';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { useFeedback } from './use-feedback';
import { cx } from '@emotion/css';

const feedbackIcon = getDesignSystemIcon('icon-speachbubble-16.svg');

export interface FeedbackFabButtonProps {
  label: string;
  position?: 'fixed' | 'sticky';
  visible: boolean;
}
export const FeedbackFabButton = forwardRef<HTMLButtonElement, FeedbackFabButtonProps>(({ label, position = 'fixed', visible }, ref) => {
  const { showFeedbackPanel, active } = useFeedback();

  if (!visible) {
    return null;
  }

  return active ? (
    <div
      className={cx(position, 'bottom-6 right-6 z-10 desktop:hidden', position === 'sticky' ? 'mr-6 flex justify-end' : '')}
      data-testid="feedbackFabButton"
    >
      <FabButton
        btnType="orange"
        icon={feedbackIcon}
        onClick={showFeedbackPanel}
        size="large"
        aria-label={label}
        ref={ref}
        aria-haspopup="dialog"
      />
    </div>
  ) : null;
});
